
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"72","height":"59","fill":"none","viewBox":"0 0 72 59"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M0 0h72v59H0z","paint-order":"markers stroke fill"}}),_c('path',{attrs:{"fill":"#dbdbdb","d":"M44 3a1.5 1.5 0 100 3h22a1.5 1.5 0 000-3zM6 7a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"}}),_c('g',{attrs:{"fill":"#0069ff","paint-order":"markers stroke fill"}},[_c('rect',{attrs:{"width":"18","height":"10","x":"6","y":"34","rx":"1","ry":"1"}}),_c('rect',{attrs:{"width":"18","height":"6","x":"6","y":"47","rx":"1","ry":"1"}}),_c('rect',{attrs:{"width":"18","height":"6","x":"48","y":"47","rx":"1","ry":"1"}})]),_c('g',{attrs:{"fill":"#e6e6e6","paint-order":"markers stroke fill"}},[_c('rect',{attrs:{"width":"60","height":"15","x":"6","y":"14","rx":"1","ry":"1"}}),_c('rect',{attrs:{"width":"18","height":"10","x":"48","y":"34","rx":"1","ry":"1"}}),_c('rect',{attrs:{"width":"18","height":"10","x":"27","y":"34","rx":"1","ry":"1"}}),_c('rect',{attrs:{"width":"18","height":"6","x":"27","y":"47","rx":"1","ry":"1"}})])])
          )
        }
      }
    